<template>
  <div
    v-if="hasError"
    id="errorId"
    role="alert"
    aria-live="assert-live"
    aria-tomic="true"
    class="invalid-feedback d-block"
  >
    {{ error }}
  </div>
</template>

<script>
export default {
  name: "BaseControlError",
  props: {
    id: {
      type: String,
      required: true
    },
    error: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasError() {
      return this.error.length > 0;
    },
    errorId() {
      return `${this.id}_error`;
    }
  }
};
</script>
